import { create } from "zustand";
import { persist } from "zustand/middleware";

const usePolicyStore = create(
  persist(
    (set) => ({
      integrationUuid: "",
      integration: null,
      setIntegrationUuid: (value) => set({ integrationUuid: value }),
      setIntegration: (value) =>
        set({
          integrationUuid: value?.integrationUuid || "",
          integration: value || null,
        }),
    }),
    {
      name: "x-policy",
      partialize: (state) => ({
        integrationUuid: state.integrationUuid,
      }),
    },
  ),
);

export default usePolicyStore;
